import {
  LocalAudioTrack,
  LocalVideoTrack,
  Participant,
  RemoteAudioTrack,
  RemoteVideoTrack,
} from "twilio-video";

const notNullAudio = (
  value: LocalAudioTrack | RemoteAudioTrack | null
): value is LocalAudioTrack | RemoteAudioTrack => {
  return value !== null;
};

/**
 * @param videoParticipant participante que deseja adquirir os tracks de áudio existentes
 * @returns audio tracks do participante, filtrando os que não estão nulos
 */
export const getExistingAudioTrack = (videoParticipant: Participant) => {
  const audioPublications = Array.from(videoParticipant.audioTracks.values());
  const existingAudioTracks = audioPublications
    .map((publication) => publication.track)
    .filter(notNullAudio);
  return existingAudioTracks;
};

const notNullVideo = (
  value: LocalVideoTrack | RemoteVideoTrack | null
): value is LocalVideoTrack | RemoteVideoTrack => {
  return value !== null;
};

/**
 * @param videoParticipant participante que deseja adquirir os tracks de vídeos existentes
 * @returns video tracks do participante, filtrando os que não estão nulos
 */
export const getExistingVideoTrack = (
  videoParticipant: Participant
): (LocalVideoTrack | RemoteVideoTrack)[] => {
  const videoPublications = Array.from(videoParticipant.videoTracks.values());
  const existingVideoTracks = videoPublications
    .map((publication) => publication.track)
    .filter(notNullVideo);
  return existingVideoTracks;
};
